import { render, staticRenderFns } from "./Clear.vue?vue&type=template&id=094e3c05&"
import script from "./Clear.vue?vue&type=script&lang=ts&"
export * from "./Clear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports